import { ReactElement } from 'react';
import { Desktop as CoreDesktop, Props } from '@client/app/components/App/Header/Desktop';
import './Desktop.scss';

export const Desktop = (props: Props): ReactElement => <CoreDesktop {...props} withBrands />;
